<template>
  <div>
    <!-- Head con Selector de Ciudad -->
    <header-page showCiudadSelector @update="ActionGetOdsObjectivos()" />
    <!-- Contenedor principal exterior -->
    <div
      :class="[
        'container ods-container',
        showMetas ? 'ods-container-indicadores' : '',
      ]"
    >
      <Breadcrumbs/>
      <!-- Logotipo Objetivos de Desarrollo Sostenible -->
      <div class="row col-12">
        <div class="title-container col-lg-7 col-md-7 col-sm-7 col-xs-12">
          <q-img
            :src="require(`@/assets/img/ods-logo-header.png`)"
            class="Imagen xs-hide"
            width="625px"
            height="60px"
            contain
          />
          <q-img
            :src="require(`@/assets/img/ods-logo-header-sm.png`)"
            class="Imagen sm-hide md-hide lg-hide xl-hide col-12"
            height="60px"
            contain
          />
        </div>
      </div>

      <!-- Contenedor interior de objetivos, metas e indicadores -->
      <div class="row col-12" style="display: flex; justify-content: space-between;">
        <!-- Contenedor del listado de objetivos -->
        <div :class="['q-col-gutter-sm container-objetivos', classWidthCol]">
          <div
            :class="['row', 'col-12', showMetas ? 'separacion' : '']"
          >
            <!-- Pantalla inicial con los 17 objetivos ocupando toda la pantalla -->
            <div
              v-if="!selectedOds"
              :class="[
                'row col-12',
                'box-container',
                'box-container-space',
              ]"
            >
              <div
                class="row col-lg-2 col-md-3 col-sm-4 col-xs-5 col-q-pt-xl q-pb-lg box-container-space"
                v-for="item in ods"
                v-bind:key="item.id"
              >
                <Contenedor
                  :datos="item"
                  :ciudadIndice="getObjetivoData(item.id)"
                  :disabled="isDisabled(item.id)"
                  :displayMetas="selectedOds && selectedOds.id === item.id"
                  @selected="(d) => selectOds(d)"
                />
              </div>
            </div>
            <!-- Contenedor del objetivo seleccionado -->
            <div
              v-else
              :class="[
                'box-container',
                selectedOds ? calcWidth(selectedOds) : restoreDefaultWidth(),
              ]"
            >
              <!-- Objetivo seleccionado con sus metas -->
              <Contenedor
                :datos="selectedOds"
                :ciudadIndice="getObjetivoData(selectedOds.id)"
                :displayMetas="true"
                @selected="(d) => closeSelectedOds(d)"
              />
            </div>
          </div>
        </div>
        <!-- Listado de indicadores -->
        <div class="col-7 container-indicadores" :style="showIndicadores ? 'display:flex;' : 'display:none;'">
          <ListadoIndicadores
            v-model="showIndicadores"
            :indicadores="indicadores"
            @close="delayAnimationWidth()"
            style="width:100%;"
          />

        </div>
        <!-- Listado de los objetivos no seleccionados -->
        <div
          class="row col-7 box-container box-container-space"
          :style="showMetas && !showIndicadores ? 'display:flex; flex-wrap: wrap;' : 'display:none;'"
        >
          <div
            class="row col-lg-2 col-md-3 col-sm-4 col-xs-5 col-q-pt-xl q-pb-lg box-container-space"
            v-for="item in odsNoSelected"
            v-bind:key="item.id"
          >
            <Contenedor
              :datos="item"
              :ciudadIndice="getObjetivoData(item.id)"
              :disabled="isDisabled(item.id)"
              :displayMetas="false"
              @selected="(d) => changeSelectedOds(d)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contenedor from '@/components/Ods/components/Contenedor.vue';
import Message from '@/components/shared/mixins/Message.js';
import ListadoIndicadores from '@/components/Indicadores/components/Listado.vue';
import { QImg } from 'quasar';
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';
import HeaderPage from '@/components/shared/HeaderPage.vue';
import Const from '@/components/shared/helpers/Const.js';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  mixins: [Message],
  components: {
    Contenedor,
    ListadoIndicadores,
    HeaderPage,
    QImg,
    Breadcrumbs
  },
  data () {
    return {
      showMetas: false,
      showIndicadores: false,
      classWidthCol: 'col-12',
      classWidthColChildren: {
        selected: 'col-8 selected-separator',
        default: 'col-5 box-container-space-open'
      },
      selectedOds: null,
      odsNoSelected: [],
      indicadores: [],
      posSelectedOds: null,
      itemOdsDeleted: null
    };
  },
  async created () {
    if (this.ciudadSelected !== null) {
      if (this.ciudadSelected.indices.indexOf(Const.ID_ODS) === -1) {
        this.$router.push({ name: 'inicio' });
      }
      await this.$store.dispatch(types.ACTION_GET_ALL_ODSOBJETIVOS)
        .then(async response => { this.ActionGetOdsObjectivos(); })
        .catch();
    }
  },
  watch: {
    ciudadSelected () {
      if (this.ciudadSelected.indices.indexOf(Const.ID_ODS) === -1) this.$router.push({ name: 'inicio' });
    }
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      ods: types.ALL_ODSOBJETIVOS,
      odsCiudad: types.ODSOBJETIVO_CIUDAD
    })
  },
  mounted () {
    this.$eventHub.$on('showIndicadoresMeta', (meta) => {
      this.showIndicadores = true;
      this.indicadores = meta.indicadores.map((e) => e.id);
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('showIndicadoresMeta');
  },
  methods: {
    isDisabled (selectedObjetivoId) {
      return !this.odsCiudad.find(objetivo => objetivo.id === selectedObjetivoId).visible;
    },
    getObjetivoData (objetivoId) {
      return this.odsCiudad.find(x => x.id === objetivoId);
    },
    restoreDefaultWidth () {
      let defaultClass = 'col-6 col-sm-4 col-md-3 col-lg-2 box-container-space';
      return defaultClass;
    },
    calcWidth (item) {
      let haveValue = false;
      if (this.selectedOds) haveValue = true;

      return haveValue && item.id === this.selectedOds.id
        ? this.classWidthColChildren.selected
        : this.classWidthColChildren.default;
    },
    removeSelected () {
      this.$store.state.NGUD.Ods.selected = {};
      this.selectedOds = null;
      this.orderObjetivos(this.ods);
    },
    async ActionGetOdsObjectivos () {
      await this.$store.dispatch(types.ACTION_GET_ODSOBJETIVO_CIUDAD).then().catch();
      this.showMetas = false;
      this.showIndicadores = false;
      this.selectedOds = null;
      this.classWidthCol = 'col-12';
    },
    delayAnimationWidth () {
      this.showIndicadores = false;
      this.showMetas = false;

      setTimeout(() => {
        this.classWidthCol = 'col-12';
        this.removeSelected();
      }, 700);
    },
    closeSelectedOds (d) {
      // Si tenemos un objetivo seleccionado y pulsamos sobre el mismo escondo las metas
      if (this.selectedOds && d.id === this.selectedOds.id) {
        this.showIndicadores = false;
        this.showMetas = false;
        this.selectedOds = null;
        this.classWidthCol = 'col-12';
      }
    },
    async changeSelectedOds (d) {
      await this.closeSelectedOds(this.selectedOds);
      this.selectOds(d);
    },
    selectOds (d) {
      this.$store.state.NGUD.Ods.selected = d;
      this.selectedOds = d;
      if (this.posSelectedOds !== null) this.odsNoSelected.splice(this.posSelectedOds, 0, this.itemOdsDeleted);
      // encotrar la posición en el array de ods del objetivo seleccionado
      this.posSelectedOds = this.ods.indexOf(this.selectedOds);
      // rellenar array de objetivos no seleccionados
      this.odsNoSelected = [...this.ods];
      this.itemOdsDeleted = this.odsNoSelected.splice(this.posSelectedOds, 1);
      this.classWidthCol = 'col-4';
      this.showMetas = true; // Cargar todos los indicadores que se necesiten con una llamada y se propague la variable para repintar.
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    orderObjetivos (data, withSelected = false) {
      let auxFirstElement = '';
      if (withSelected) {
        // Nos guardamos el primer valor para no ordenarlo.
        auxFirstElement = data[0];
        data.splice(0, 1);
      }

      let sortData = data;
      sortData.sort((a, b) => {
        return a.order - b.order;
      });

      if (withSelected) sortData.splice(0, 0, auxFirstElement);

      return sortData;
    }
  }
};
</script>

<style lang="scss" scoped>
.ods-container-indicadores {
  padding-right: 33px !important;
  transition: padding 1s;
  .separacion {
    display: flex;
    justify-content: space-between;
  }
}
.ods-container {
  transition: padding 1s;
  .title-container {
    display: flex;
    padding-bottom: 24px;
    margin-left: 5px;
  }

  .container-objetivos {
    transition: width 1s;
  }

  .box-container-space {
    margin-left: 17px;
    margin-right: 17px;
    margin-top:0px;
    margin-bottom: 0px;
  }

  .box-container-space-open {
    margin: 5px;
  }

  .selected-separator {
    padding-bottom: 68px;
  }

  .txt-return {
    margin-left: 12px !important;
    div {
      margin-left: 6px !important;
    }
  }
  .action-button {
    padding-top: 24px;
    padding-bottom: 12px;
  }
}
</style>
